class PushCard extends window.BAO.CustomElement() {
  setupListeners () {
    this.handleSelect = this.handleSelect.bind(this)

    if (this?.els?.select?.exists && this?.els?.button?.exists) {
      this.listeners.add(this.els.select.element, `change`, this.handleSelect)
    }
  }

  handleSelect (e) {
    const selectedOption = e.target.options[e.target.selectedIndex]
    const dataLabel = selectedOption.getAttribute('data-label')
    const isDisabled = selectedOption.disabled
    const hasValue = selectedOption.value !== ''

    this.els.button.element.setAttribute('aria-label', dataLabel)
    
    if (hasValue && !isDisabled) {
      this.els.button.element.removeAttribute('disabled')
    } else {
      this.els.button.element.setAttribute('disabled', 'disabled')
    }
  }
}

if (!customElements.get('push-card')) {
  customElements.define('push-card', PushCard)
}
